var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Trail_1;
import React, { PureComponent } from 'react';
import { Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, element, eventListener, expression, object, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isFunction, propagateProps } from '@philips-internal/oswald-ui-utils';
import { CardList } from '../card-list/card-list.js';
import { Link } from '../link/link.js';
import TrailAPI from './trail-api.js';
import { TrailPageItemsNumber } from './trail-constants.js';
import { getActualPageCount } from './trail-utils.js';
import './trail.css';
function Dot(props) {
    const { active, onClick, page } = props;
    const dotClasses = {
        'c-trail__dot': true,
        'is-active': Boolean(active),
    };
    return (React.createElement("li", { className: classNames(dotClasses), onClick: () => onClick(page) }));
}
function Nav(props) {
    const { direction, onClick } = props;
    const clasz = `c-trail__nav c-trail__nav--${direction} u-hide@xsm u-hide@sm`;
    return React.createElement("div", { className: clasz, onClick: (event) => onClick(event) });
}
let Trail = Trail_1 = class Trail extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            page: 0,
        };
        this.getPageCount = () => {
            const { canAddNewItem, data = Trail_1.defaultProps.data, itemsPerPage = Trail_1.defaultProps.itemsPerPage, } = this.props;
            return getActualPageCount({ canAddNewItem, data, itemsPerPage });
        };
        this.getPlaceholderCount = () => {
            const { canAddNewItem, data = Trail_1.defaultProps.data, itemsPerPage = Trail_1.defaultProps.itemsPerPage, } = this.props;
            const totalCards = canAddNewItem ? data.length + 1 : data.length;
            const difference = totalCards % itemsPerPage;
            if (difference) {
                return itemsPerPage - difference;
            }
            return 0;
        };
        this.incrementPage = (increment) => {
            const { page } = this.state;
            const nextPage = page + increment;
            const isValid = nextPage != page && (nextPage >= 0 && nextPage <= this.getPageCount());
            if (isValid) {
                this.updatePage(nextPage);
            }
        };
        this.isNavigable = () => {
            const { canAddNewItem, data = Trail_1.defaultProps.data, itemsPerPage = Trail_1.defaultProps.itemsPerPage, } = this.props;
            const items = data.length + (canAddNewItem ? 1 : 0);
            return items > itemsPerPage;
        };
        this.updatePage = (page) => {
            this.setState({ page });
        };
        this.onSeeAllClick = () => {
            const { onSeeAllClick } = this.props;
            if (isFunction(onSeeAllClick)) {
                onSeeAllClick(new ClickEvent());
            }
        };
        this.onNewCardClick = () => {
            const { onNewCardClick } = this.props;
            if (isFunction(onNewCardClick)) {
                onNewCardClick(new ClickEvent());
            }
        };
        this.onClick = (event) => {
            const { onClick } = this.props;
            isFunction(onClick) && onClick(new ClickEvent({ value: event.value }));
        };
        this.onDoubleClick = (event) => {
            const { onDoubleClick } = this.props;
            isFunction(onDoubleClick) && onDoubleClick(new ClickEvent({ value: event.value }));
        };
        this.onContextMenuClick = (event) => {
            const { onContextMenuClick } = this.props;
            isFunction(onContextMenuClick) && onContextMenuClick(new ClickEvent({ value: event.value }));
        };
        this.renderDots = () => {
            const { loading } = this.props;
            const { page } = this.state;
            const pageCount = this.getPageCount();
            if (loading || !this.isNavigable() || !pageCount) {
                return null;
            }
            const elements = [];
            for (let index = 0; index <= pageCount; index++) {
                elements.push(React.createElement(Dot, { active: index === page, key: index, onClick: this.updatePage, page: index }));
            }
            return React.createElement("ul", { className: "c-trail__dots" }, elements);
        };
        this.renderNavPrev = () => {
            const { loading } = this.props;
            const { page } = this.state;
            if (loading || !this.isNavigable() || page === 0) {
                return null;
            }
            return React.createElement(Nav, { direction: "prev", onClick: () => this.incrementPage(-1) });
        };
        this.renderNavNext = () => {
            const { loading } = this.props;
            const { page } = this.state;
            if (loading || !this.isNavigable() || page === this.getPageCount()) {
                return null;
            }
            return React.createElement(Nav, { direction: "next", onClick: () => this.incrementPage(1) });
        };
        this.renderCards = () => {
            const { canAddNewItem, children, data = Trail_1.defaultProps.data, dateVisible, emptyResultSubtitle, emptyResultTitle, itemsPerPage = Trail_1.defaultProps.itemsPerPage, loading, newItemText, uuid, } = this.props;
            const { page } = this.state;
            const percentage = page * 100 * -1;
            const sliderStyle = {
                transform: `translateX(calc(${percentage}% - calc(${page} * var(--col-gap)))`,
            };
            const columnSize = Math.floor(12 / itemsPerPage);
            const gridSpanClass = `u-grid-col-${columnSize}@lg u-grid-col-${columnSize}@md`;
            const className = `c-trail__add-new-card ${gridSpanClass}`;
            return (React.createElement(CardList, { addNewClassName: className, addNewExpression: newItemText, className: "c-trail__slider", data: data, emptyResultSubtitleExpression: emptyResultSubtitle, emptyResultTitleExpression: emptyResultTitle, loading: loading, noWrap: true, onAddNewClick: this.onNewCardClick, onClick: this.onClick, onContextMenuClick: this.onContextMenuClick, onDoubleClick: this.onDoubleClick, placeholderCount: this.getPlaceholderCount(), showAddNew: canAddNewItem, showDates: dateVisible, style: sliderStyle, uuid: uuid }, propagateProps(children, { className: `u-grid-col-4 ${gridSpanClass}` })));
        };
        this.renderSeeAllLink = () => {
            const { loading, seeAll, showSeeAll } = this.props;
            if (!showSeeAll || loading || !this.isNavigable()) {
                return null;
            }
            return (React.createElement(Link, { className: "c-trail__all", onClick: this.onSeeAllClick, size: Size.MEDIUM, value: seeAll }));
        };
    }
    render() {
        const { dateVisible, loading, title = '' } = this.props;
        const rootClasses = {
            'c-trail': true,
            'c-trail--no-date': !dateVisible,
            'is-loading': Boolean(loading),
        };
        return (React.createElement("div", { className: classNames(rootClasses) },
            title.trim() &&
                React.createElement("div", { className: "c-trail__title" }, MessageService.translate(title)),
            React.createElement("div", { className: "c-trail__container" },
                this.renderNavPrev(),
                React.createElement("div", { className: "c-trail__viewport" }, this.renderCards()),
                this.renderNavNext()),
            React.createElement("div", { className: "c-trail__footer u-hide@xsm u-hide@sm" },
                this.renderDots(),
                this.renderSeeAllLink())));
    }
};
Trail.propTypes = {
    canAddNewItem: bool,
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    data: arrayOf(object).notEnumerable(),
    dateVisible: bool,
    emptyResultSubtitle: expression,
    emptyResultTitle: expression,
    itemsPerPage: oneOf([
        TrailPageItemsNumber.ONE,
        TrailPageItemsNumber.TWO,
        TrailPageItemsNumber.THREE,
        TrailPageItemsNumber.FOUR,
        TrailPageItemsNumber.SIX,
        TrailPageItemsNumber.TWELVE,
    ]),
    loading: bool,
    newItemText: expression,
    onClick: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
    onNewCardClick: eventListener,
    onSeeAllClick: eventListener,
    seeAll: expression,
    showSeeAll: bool,
    title: expression,
    uuid: string,
};
Trail.defaultProps = {
    canAddNewItem: true,
    data: [],
    dateVisible: true,
    itemsPerPage: TrailPageItemsNumber.FOUR,
    loading: false,
    newItemText: 'tws.trail.add-new',
    seeAll: 'tws.trail.see-all',
    showSeeAll: true,
    title: '',
};
Trail = Trail_1 = __decorate([
    AwesomeComponent({ api: TrailAPI, type: ComponentType.LIST })
], Trail);
export default Trail;
//# sourceMappingURL=trail.js.map